import { z } from 'zod';
import { booleanQuery, idSchema, intSchema, moneySchema, optionalText, paginationQuerySchema, requiredText } from './common';

export const productCreateSchema = z.object({
  name: requiredText(120, 'Nome do produto'),
  sku: optionalText(60, 'Código / SKU'),
  price: moneySchema,
  /** Preço de custo (quanto a loja pagou) — base para o financeiro / margem. */
  costPrice: moneySchema.optional(),
  warrantyDays: intSchema('Garantia', 0, 3650),
  /** Avisa quando o estoque chegar a esta quantidade (ou menos). */
  minStock: intSchema('Estoque mínimo', 0, 100_000).optional(),
  /** Estoque inicial — só vale no cadastro e só o administrador pode informar. */
  initialStock: intSchema('Estoque inicial', 0, 1_000_000).optional(),
  physicalLocation: optionalText(120, 'Localização física'),
  categoryId: idSchema.nullish(),
  supplierId: idSchema.nullish(),
  brandIds: z.array(idSchema).optional().default([]),
  active: z.boolean().optional(),
});
export const productUpdateSchema = productCreateSchema.omit({ initialStock: true }).partial();
export type ProductCreateInput = z.infer<typeof productCreateSchema>;
export type ProductUpdateInput = z.infer<typeof productUpdateSchema>;
export type ProductFormValues = z.input<typeof productCreateSchema>;

export const serviceCatalogCreateSchema = z.object({
  name: requiredText(120, 'Nome do serviço'),
  price: moneySchema,
  warrantyDays: intSchema('Garantia', 0, 3650),
  active: z.boolean().optional(),
});
export const serviceCatalogUpdateSchema = serviceCatalogCreateSchema.partial();
export type ServiceCatalogCreateInput = z.infer<typeof serviceCatalogCreateSchema>;
export type ServiceCatalogUpdateInput = z.infer<typeof serviceCatalogUpdateSchema>;
export type ServiceCatalogFormValues = z.input<typeof serviceCatalogCreateSchema>;

export const catalogListQuerySchema = paginationQuerySchema.extend({
  includeInactive: booleanQuery,
  /** Somente itens com estoque no mínimo ou abaixo (produtos e componentes). */
  lowStock: booleanQuery,
  pageSize: z.coerce.number().int().min(1).max(500).default(100),
});

/** Referência reutilizável: categoria, marca ou fornecedor. */
export const catalogReferenceCreateSchema = z.object({
  name: requiredText(80, 'Nome'),
});
export const catalogReferenceUpdateSchema = catalogReferenceCreateSchema.partial().extend({
  active: z.boolean().optional(),
});
export type CatalogReferenceCreateInput = z.infer<typeof catalogReferenceCreateSchema>;
export type CatalogReferenceUpdateInput = z.infer<typeof catalogReferenceUpdateSchema>;

export const catalogReferencesListQuerySchema = paginationQuerySchema.extend({
  includeInactive: booleanQuery,
  pageSize: z.coerce.number().int().min(1).max(500).default(100),
});

/** Garantia padrão quando o item é cadastrado (regra do protótipo). */
export const DEFAULT_PRODUCT_WARRANTY_DAYS = 0;
export const DEFAULT_SERVICE_WARRANTY_DAYS = 90;
